"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialiser = function initialiser(settings, Module) {
  if (!settings || !settings.selector) return false;

  var elements = document.querySelectorAll(settings.selector);

  if (!elements || !elements.length) return false;

  var instances = [].concat(_toConsumableArray(elements)).map(function (el) {
    var instance = new Module({ el: el, settings: settings });
    instance.init();
    return instance;
  });

  return instances;
};

exports.default = initialiser;